import { Injectable } from '@angular/core';
import { FormExtractorService } from 'src/app/modules/shared/services/form-extractor.service';
import { Rectificatif } from '../models/Rectificatif';
import { FormmapaRectificatifServices } from './formmapa-rectificatif/formmapa-rectificatif-services.service';
import { LogService } from 'src/app/modules/shared/services/log.service';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { Avis } from 'src/app/models/avis';
import { Annonce } from '../../../common/models/annonce';
import { StatutAvisEnum } from '../../../../../models/enums/statut-avis.enum';
import { MapaService } from '../../common/services/mapa/mapa.service';
import { CommonService } from '../../../common/services/common/common.service';
import { MAPA } from '../../common/models/MAPA';
import { TypeAvisEnum } from '../../../../../models/enums/type-avis.enum';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';

@Injectable({
  providedIn: 'root'
})
export class FormmapaRecExtractorService {

  private LOG: LogService = new LogService(FormmapaRecExtractorService);

  constructor(private formExtractorService: FormExtractorService, private formmapaRectificatifServices: FormmapaRectificatifServices,
    private mapaService: MapaService,
    private commonService: CommonService,
    private avisDataTransferService: AvisDataTransferService) {
  }

  public mapFormToAvis(form, stepId, actualFormIdAnnEmetteur): Avis {
    const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
    const rectificatif = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.rectificatifFromMAPA;
    if(stepId == 3) {
      rectificatif.description = this.formmapaRectificatifServices.descriptionService.getDescription(controls, this.formExtractorService);
    }
    if(stepId == 4) {
      rectificatif.infosRectif = this.formmapaRectificatifServices.infosRectifService.getInfosRectif(controls, this.formExtractorService);
    }
    if(stepId == 1) {
      rectificatif.avisInitial = this.formmapaRectificatifServices.avisInitialService.getAvisInitial(controls);
    }
    rectificatif.procedure = this.formmapaRectificatifServices.procedureService.getProcedure(controls);
    const mapa: MAPA = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa;
    if(stepId == 2) {
		  mapa.organisme = this.mapaService.organismeService.getOrganisme(controls);
    }
		mapa.initialFromMAPA = null;
		mapa.attributionFromMAPA = null;
		mapa.rectificatifFromMAPA = rectificatif;
    mapa.annulationFromMAPA = null;

    const annonce: Annonce = new Annonce();
		annonce.ann.idAnnEmetteur = actualFormIdAnnEmetteur;
    annonce.ann.divers = null;
		annonce.ann.mapa = mapa;
		annonce.ann.fnSimple = null;
		annonce.ann.formAD = null;
    annonce.ann.facturation = this.commonService.facturationService.getFacturation(form, 'DIV', controls);
    annonce.ann.indexation = this.commonService.indexationService.getIndexation(form);
    annonce.ann.dateEnvoi = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepAtt_dateEnvoi');

    annonce.annonceur.login = controls.get('_SepSep_idAnnonceur_SepAtt_idannonceurboampweb');
		annonce.annonceur.mail = controls.get('_SepSep_idAnnonceur_SepAtt_mailcontactboampweb');
		//Nettoyer les blocs inexistants
    annonce.ann.mapa.rectificatifFromMAPA.description.marcheTravaux = null;
    annonce.ann.mapa.rectificatifFromMAPA.procedure.procedureAdaptee = "";
    const avis: Avis = new Avis();
    avis.jsonSaisieFormulaire = annonce;
    avis.formulaire.code = FormsEnum[FormsEnum.MAPA_RE];
    avis.statut = StatutAvisEnum.ELABORE;
    avis.critere.typeAvis.code=TypeAvisEnum.C4_4;
    return avis;
  }
}

